import React from "react";
import { Table, Button, Tag } from "antd";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import useStockMovementContext from "../../../../hooks/useStockMovementContext";
import { Creators as StockMovementActions } from "../../../../store/ducks/stockMovement";
import {
  TYPE_TAG_COLOR,
  STATUS_TAG_COLOR,
  toI18nKey,
} from "./stockMovementConstants";

const numberToBRL = (value) =>
  (value || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const StockMovementTable = () => {
  const { translation } = useSelector((state) => state.app);
  const tm = translation?.stockItem?.movements || {};
  const t = tm.table || {};

  const {
    data,
    isLoading,
    pagination,
    searchTerm,
    filterType,
    stockItems,
    handleOpenDetail,
  } = useStockMovementContext();

  const dispatch = useDispatch();

  const movements = Array.isArray(data) ? data : [];

  const getItem = (stockItemId) =>
    stockItems.find((i) => i.id === stockItemId) || null;

  const label = (group, value) =>
    (tm[group] && tm[group][toI18nKey(value)]) || value || "-";

  const filtered = movements
    .filter((m) => {
      if (filterType === "ALL") return m.status !== "INACTIVE";
      if (filterType === "INACTIVE") return m.status === "INACTIVE";
      return m.type === filterType;
    })
    .filter((m) => {
      if (!searchTerm) return true;
      const term = searchTerm.toLowerCase();
      const item = getItem(m.stockItemId);
      return (
        (m.nfReference || "").toLowerCase().includes(term) ||
        (item?.abbreviation || "").toLowerCase().includes(term) ||
        (item?.description || "").toLowerCase().includes(term)
      );
    });

  const columns = [
    {
      title: t.type || "Tipo",
      key: "type",
      render: (_, record) => (
        <Tag color={TYPE_TAG_COLOR[record.type]}>
          {label("type", record.type)}
        </Tag>
      ),
    },
    {
      title: t.origin || "Origem",
      key: "origin",
      render: (_, record) =>
        record.type === "ENTRY"
          ? label("entryOrigins", record.origin)
          : label("exitOrigins", record.origin),
    },
    {
      title: t.totalCost || "Custo Total",
      dataIndex: "totalCost",
      key: "totalCost",
      align: "right",
      render: (val) => (val != null ? numberToBRL(val) : "-"),
    },
    {
      title: t.status || "Status",
      key: "status",
      render: (_, record) => (
        <Tag color={STATUS_TAG_COLOR[record.status]}>
          {label("status", record.status)}
        </Tag>
      ),
    },
    {
      title: t.date || "Data",
      dataIndex: "stockMovementDate",
      key: "stockMovementDate",
      defaultSortOrder: "descend",

      sorter: (a, b) =>
        moment(a.stockMovementDate).unix() - moment(b.stockMovementDate).unix(),

      render: (val) => (val ? moment(val).format("DD/MM/YYYY") : "-"),
    },
    {
      title: t.user || "Usuário",
      dataIndex: "userName",
      key: "userName",
      render: (val) => val || "-",
    },
    {
      title: t.actions || "Ações",
      key: "actions",
      width: 60,
      align: "center",
      render: (_, record) => (
        <Button
          size="small"
          icon="eye"
          onClick={() => handleOpenDetail(record)}
        />
      ),
    },
  ];

  const handleTableChange = (paginationInfo) => {
    // dispatch(
    //   StockMovementActions.indexStockMovement(
    //     groupId,
    //     farmId,
    //     paginationInfo.current - 1,
    //     paginationInfo.pageSize,
    //   ),
    // );
    dispatch(
      StockMovementActions.changeStockMovementPagination(
        paginationInfo.current - 1,
        paginationInfo.pageSize,
      ),
    );
  };

  return (
    <Table
      rowKey="id"
      loading={isLoading}
      columns={columns}
      dataSource={filtered}
      size="small"
      scroll={{ x: true }}
      locale={{ emptyText: tm.emptyTable || "Nenhum movimento encontrado." }}
      onChange={handleTableChange}
      pagination={{
        current: (pagination?.page || 0) + 1,
        pageSize: pagination?.size || 15,
        total: pagination?.total || filtered.length,
        showSizeChanger: true,
        pageSizeOptions: ["15", "30", "50", "100"],
      }}
    />
  );
};

export default StockMovementTable;
